import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import * as React from 'react';

export type PageTitleProps = {
    title: string;
    description?: string;
}

const StyledPageTitle = styled(Box)({
    display: 'flex',
    marginBottom: '24px',
    alignItems: 'center',
    flexDirection: 'column',
});

const StyledTitleText = styled(Box)(() => ({
    flexGrow: 1,
    fontSize: '32px',
    letterSpacing: '0',    
    color: 'rgb(21, 41, 53)',
    margin: '0px 0px 16px',
    padding: '2px 0px',
    textAlign: 'center',
    fontFamily: 'Cairo',
    fontWeight: 700,
    lineHeight: '3rem',
    backgroundColor: 'white',
}));

const StyledDescriptionText = styled(Box)(() => ({
    color: 'rgb(96, 95, 96)',
    fontSize: '1rem',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    lineHeight: '1.5rem',
    letterSpacing: '0.15px',
}));

export const VdsPageTitle: React.FC<PageTitleProps> = (props) => {

    const { title, description } = props;

    return (
        <StyledPageTitle>
            <StyledTitleText>{title.toUpperCase()}</StyledTitleText>
            <StyledDescriptionText>{description}</StyledDescriptionText>
        </StyledPageTitle>
    );
}
